import * as React from "react";
const SvgFiRrBenchTree = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bench-tree_svg__a)">
      <path
        fill="#062147"
        d="M15 13.5c0-1.93-1.57-3.5-3.5-3.5h-8C1.57 10 0 11.57 0 13.5c0 1.393.819 2.599 2 3.162V19H1a1 1 0 1 0 0 2h1v2a1 1 0 1 0 2 0v-2h7v2a1 1 0 1 0 2 0v-2h1a1 1 0 1 0 0-2h-1v-2.338a3.51 3.51 0 0 0 2-3.162M3.5 12h8c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-8c-.827 0-1.5-.673-1.5-1.5S2.673 12 3.5 12m.5 7v-2h7v2zm19.544-8.839c.448.883.562 1.808.356 2.729-.442 1.985-2.284 3.28-4.365 3.09-.195-.024-.32.019-.412.102a.36.36 0 0 0-.124.279v6.64a1 1 0 1 1-2 0v-6.64c0-.674.287-1.318.786-1.767a2.45 2.45 0 0 1 1.903-.609c1.107.097 2.04-.54 2.259-1.528a1.97 1.97 0 0 0-.16-1.335c-.18-.347-.556-1.071-.005-2.23a2.1 2.1 0 0 0 .216-.891c0-.646-.318-1.253-.852-1.625-.741-.519-1.17-1.39-1.148-2.331a2.1 2.1 0 0 0-.158-.822 1.96 1.96 0 0 0-1.273-1.146 2.15 2.15 0 0 0-1.138 0c-.56.15-1.047.589-1.272 1.146a2.05 2.05 0 0 0-.158.822c.022.941-.407 1.812-1.148 2.33-.534.373-.853.98-.853 1.626a1 1 0 1 1-2 0c0-1.299.638-2.52 1.708-3.266.264-.185.297-.482.294-.644a4 4 0 0 1 .303-1.619A3.94 3.94 0 0 1 16.912.145a4.2 4.2 0 0 1 2.172 0 3.94 3.94 0 0 1 2.61 2.327c.214.529.316 1.074.303 1.619-.003.161.03.459.294.645a3.98 3.98 0 0 1 1.707 3.265c0 .589-.138 1.177-.41 1.749-.104.218-.096.307-.096.307.003.016.032.069.05.105z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bench-tree_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBenchTree;
